export const ALL_SELECTED = {
  value: -1,
  label: 'All',
};

export const NATIONAL_SELECTED = {
  value: -1,
  label: 'National',
};

export const mapToNullIfAllSelected = (value) => (value === -1 ? null : value);

export const mapToAllIfNull = (id, label) =>
  !id
    ? ALL_SELECTED
    : {
        value: id?.toString(),
        label: label?.toString(),
      };

export const mapToNationalIfNull = (id, label) =>
  !id
    ? NATIONAL_SELECTED
    : {
        value: id?.toString(),
        label: label?.toString(),
      };
